import React, { useRef, useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { IconContext } from 'react-icons';
import { ImArrowLeft2 } from 'react-icons/im';
import { Button } from 'reactstrap';
import {
  getCloudImageUrl,
  convertToRupiah,
  formatCurrencyWithMinus,
} from '../../utils';
import styled from 'styled-components';
import { RESOURCE_URL } from '../../config';
import BodyTab from './KickCreditTabs/BodyTab';
import { doTopUp, walletHistory } from '../../actions/topUpAction';
import { doFetchUserBankAccount } from '../../actions/postalCodeAction';
import {
  doDisbursement,
  disbursementHistory,
  cashOutHistory,
  getDisbursementSetting,
  getSellerCashOutFee,
} from '../../actions/disbursementAction';
import { doFetchProfile, doRefreshToken } from '../../actions/authAction';
import {
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  doSubmitPhone,
} from '../../actions/saleActions';
import RouteHistoryInterface from '../../interface/router';
const userBalanceIcon = `${RESOURCE_URL}icons/sellercredit.png`;
import CashoutForm from './Modals/CashoutForm';
import Paginations from './Pagination/Pagination';
import UserBalanceInfoModal from './Modals/UserBalanceInfoModal';
import SellerVerification from '../PageSellerRegistration/SellerVerification';
import ModalUnverifiedUser from 'Pages/Home/Components/Organisms/ModalUnverifiedUser';

const TABS = [
  {
    title: 'Pending Cash Out',
    value: 'pending_cashout',
  },
  {
    title: 'Wallet Logs',
    value: 'wallet_logs',
  },
];

const IconReminder = styled.div`
  background-color: #159953;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  width: 15px;
  height: 15px;
  padding: 9px;
  margin-left: 5px;
`;
interface sellerCreditHistory extends stateToProps {
  isSubmit: boolean;
  dataUser: Array<Object>;
  dataCashOut: Array<Object>;
  dataWalletLog: Array<Object>;
  dataUserBank: Array<Object>;
  dataDisbursement: Array<Object>;
  dataSetting: any;
  dataAuth: any;
  dataCashOutFee: any;
  history: RouteHistoryInterface;
  doPendingCashOut: (payload: any) => Promise<any>;
  topUpHistory: (payload: any) => Promise<any>;
  doDisbursement: (payload: any) => Promise<any>;
  doDisbursementHistory: (payload: any) => Promise<any>;
  getUserBankAccount: () => Promise;
  getDisbursementSetting: () => Promise;
  getSellerCashOutFee: (payload: any) => Promise<any>;
  getProfile: () => Promise<any>;
}

function SellerCreditHistory({
  isSubmit,
  dataUser,
  dataCashOut,
  dataWalletLog,
  dataUserBank,
  dataDisbursement,
  dataSetting,
  dataCashOutFee,
  history,
  doPendingCashOut,
  topUpHistory,
  doDisbursement,
  doDisbursementHistory,
  getUserBankAccount,
  getDisbursementSetting,
  getSellerCashOutFee,
  getProfile,
  doSubmitPhone,
  doRefreshToken,
  doVerifyOtp,
  doSentCitCall,
  doSentSMS,
  dataAuth,
  ...props
}: sellerCreditHistory): JSX.Element {
  const isSellerCreditMinus =
    parseInt(dataAuth?.userdata?.balance_with_fee ?? '0') < 0;
  const prevSubmit = usePrevious(isSubmit);
  const [status, setStatus] = useState('pending_cashout');
  const [activeTabs, setActiveTabs] = useState('pending_cashout');
  const prevAtiveTabs = usePrevious(activeTabs);
  const [isModalOpened, setModalOpened] = useState(false);
  const [isResetModal, setResetModal] = useState(false);

  //seller verification
  const [isOpenSellerVerification, setOpenSellerVerification] = useState(false);
  const [phone, setPhone] = useState('');
  const [isOpenExistingModal, setIsOpenExistingModal] = useState(false);
  //end seller verification

  const prevIsOpen = usePrevious(isModalOpened);
  const toggleCashout = () => setModalOpened(!isModalOpened);
  const holdBalance =
    parseInt(dataUser.current_balance_with_fee) -
    parseInt(dataUser.balance_with_fee);
  const [params, setParams] = useState({
    params: {
      sort_by: 'createdAt_desc',
      balance_source: 'balance_with_fee',
    },
  });
  const [isOpenSellerInfo, onSellerInfoToggle] = useState(false);

  const [isShowModal, setIsShowModal] = useState(false);
  const [unverifiedType, setUnverifiedType] =
    useState<
      'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account'
    >('Top Up');

  const onClickUnverifiedUser = (
    val: 'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account',
  ) => {
    setIsShowModal(true);
    setUnverifiedType(val);
  };

  useEffect(() => {
    getList(activeTabs);
    getDisbursementSetting();
    if (dataUserBank.length === 0) getUserBankAccount();
  }, []);

  //seller verification
  function toggleSellerVerification() {
    setOpenSellerVerification(!isOpenSellerVerification);
  }
  function toggleExistingModal() {
    setIsOpenExistingModal(!isOpenExistingModal);
  }
  function toggleCashoutVerification() {
    if (dataAuth.userdata.roles.includes('unverified_user')) {
      onClickUnverifiedUser('Cash Out');
      return;
    }
    if (
      !dataUser.seller_verification &&
      dataUser.country_code === 'IDN' &&
      dataUser.roles.includes('seller')
    ) {
      toggleSellerVerification();
      setIsOpenExistingModal(!isOpenExistingModal);
    } else {
      toggleCashout();
    }
  }
  //end seller verification

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }

  const componentDidUpdate = async (
    prevSubmit = false,
    isSubmit,
    prevIsOpen = false,
    isModalOpened,
    prevAtiveTabs,
    history,
  ) => {
    if (prevSubmit !== isSubmit && prevSubmit) getList(activeTabs);
    if (prevIsOpen !== isModalOpened) {
      let isOpen = !isModalOpened ? true : false;
      setResetModal(isOpen);
    }
    if (
      prevAtiveTabs &&
      history.location.state &&
      history.location.state.activeTab &&
      isResetModal &&
      prevAtiveTabs !== history.location.state.activeTab
    ) {
      setActiveTabs(history.location.state.activeTab);
    }
  };
  useEffect(() => {
    componentDidUpdate(
      prevSubmit,
      isSubmit,
      prevIsOpen,
      isModalOpened,
      prevAtiveTabs,
      history,
    );
  }, [prevSubmit, isSubmit, prevIsOpen, isModalOpened, prevAtiveTabs, history]);

  function handleChangeTabs(targetTab: string) {
    setStatus(targetTab);
    setActiveTabs(targetTab);
    getList(targetTab);
  }

  const getList = (activeTabs) => {
    switch (activeTabs) {
      case 'pending_cashout':
        doPendingCashOut(params.params);
        break;
      case 'wallet_logs':
        doDisbursementHistory(params);
        break;
      default:
        return doPendingCashOut(params.params);
    }
  };

  const paginationEachTab = (tab) => {
    switch (tab) {
      case 'pending_cashout':
        return (
          dataCashOut.status_code === 200 &&
          dataCashOut.dataCashOut.length !== 0
        );
      case 'wallet_logs':
        return (
          dataWalletLog.status_code === 200 &&
          dataWalletLog.dataBalance.length !== 0
        );
      default:
        return false;
    }
  };

  const checkPageTab = (tab, keys) => {
    switch (tab) {
      case 'pending_cashout':
        return dataCashOut[keys];
      case 'wallet_logs':
        return dataWalletLog[keys];
      default:
        return 0;
    }
  };

  const handleToGo = (e, page) => {
    e.preventDefault();
    setParams({
      params: {
        ...params.params,
        page,
      },
    });
  };

  const onClickBack = () => {
    history.push('/user_dashboard');
  };

  function handleCashOutSubmit(payloads) {
    doDisbursement(payloads).then(() => getProfile());
  }

  useEffect(() => {
    getList(activeTabs);
  }, [params]);

  const RenderPagination = () => {
    if (paginationEachTab(activeTabs)) {
      return (
        <Paginations
          currentPage={checkPageTab(activeTabs, 'current_page')}
          lastPage={checkPageTab(activeTabs, 'last_page')}
          perPage={checkPageTab(activeTabs, 'per_page')}
          total={checkPageTab(activeTabs, 'total')}
          prevPageUrl
          handleGoto={handleToGo}
          nextPageUrl
          maxPage={5}
        />
      );
    }
    return null;
  };

  function renderTabContent(currentActiveTab: string) {
    switch (currentActiveTab) {
      case 'pending_cashout':
        return (
          <BodyTab
            title="Pending Cashout"
            icon={getCloudImageUrl(userBalanceIcon, 400)}
            onRefreshList={() => getList(currentActiveTab)}
            data={dataCashOut.dataCashOut}
            type="CASHOUT"
            RenderPagination={RenderPagination}
          />
        );
      case 'wallet_logs':
        return (
          <BodyTab
            title="Wallet Logs"
            icon={getCloudImageUrl(userBalanceIcon, 400)}
            onRefreshList={() => getList(currentActiveTab)}
            data={dataWalletLog.dataBalance}
            type="WALLET_LOGS"
            RenderPagination={RenderPagination}
          />
        );
      default:
        return;
    }
  }
  return (
    <div className={'kick-credit-container'}>
      {isOpenSellerVerification && (
        <SellerVerification
          isExistingSeller={
            !dataUser.seller_verification && dataUser.roles.includes('seller')
          }
          isOpen={isOpenSellerVerification}
          toggle={toggleSellerVerification}
          doRefreshToken={doRefreshToken}
          doVerifyOtp={doVerifyOtp}
          doSentCitCall={doSentCitCall}
          doSentSMS={doSentSMS}
          doSubmitPhone={doSubmitPhone}
          phoneNumber={phone}
          setPhone={setPhone}
          toggleExistingModal={toggleExistingModal}
          isOpenExistingModal={isOpenExistingModal}
          setIsOpenExistingModal={setIsOpenExistingModal}
        />
      )}
      <CashoutForm
        title="Seller Credit"
        amountFee={dataCashOutFee.amount_fee}
        balance_source="BALANCE_WITH_FEE"
        icon={getCloudImageUrl(userBalanceIcon, 400)}
        dataSetting={dataSetting}
        isOpen={isModalOpened}
        onToggle={toggleCashout}
        onSubmit={handleCashOutSubmit}
        balance={dataUser.balance_with_fee}
        bankAccount={dataUserBank}
        dataDisburse={dataDisbursement}
        dataPassword={dataUserBank.have_password}
        handleChangeTabs={() => handleChangeTabs('wallet_logs')}
        getSellerCashOutFee={getSellerCashOutFee}
        history={history}
      />
      <UserBalanceInfoModal
        isOpen={isOpenSellerInfo}
        onToggle={() => onSellerInfoToggle(!isOpenSellerInfo)}
        cashOutFee={dataSetting?.cashout_fee ?? 0}
        adminFee={dataSetting?.admin_fee ?? 0}
      />
      <div className={'title-container'}>
        <div className={'back-button'} onClick={onClickBack}>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <ImArrowLeft2 />
            </div>
          </IconContext.Provider>
        </div>
        <span className={'title'}>Seller Credit</span>
      </div>
      <div className={'kick-credit-info'}>
        <div className="balance-icon">
          <KickImage src={getCloudImageUrl(userBalanceIcon, 400)} />
        </div>
        <div
          className={`balance-info ${
            isSellerCreditMinus ? 'credit-minus' : ''
          }`}
        >
          <span>Balance</span>
          <span
            className={`${
              parseInt(dataUser.balance_with_fee) < 0 ? 'minus' : ''
            }`}
          >
            {formatCurrencyWithMinus(
              parseInt(dataUser.balance_with_fee),
              props.ratio,
              props.currency,
            )}
          </span>
          <span
            style={{ color: '#159953', cursor: 'pointer' }}
            onClick={() => onSellerInfoToggle(!isOpenSellerInfo)}
          >
            <strong>What is Seller Credit?</strong>
          </span>
        </div>
        <div className={'button-wrapper'}>
          <Button onClick={toggleCashoutVerification}>Cash Out</Button>
        </div>
      </div>
      <div className="hold-balance-wrapper">
        <span>
          On Hold Balance: <strong>IDR {convertToRupiah(holdBalance)}</strong>
        </span>
        {/* <IconReminder>!</IconReminder> */}
      </div>
      <div className={'tab-container'}>
        <div className="tab-header-wrapper">
          {TABS.map((t, i) => {
            let classDiv = 'tabs';
            if (activeTabs === t.value) classDiv += ' active';
            return (
              <div
                key={i}
                className={classDiv}
                onClick={() => handleChangeTabs(t.value)}
              >
                {t.title}
                {activeTabs === t.value && <div className={'is-active-tabs'} />}
              </div>
            );
          })}
        </div>
        <div className="pagination-wrapper d-none d-sm-block">
          {RenderPagination()}
        </div>
      </div>
      <div className={'tab-content'}>{renderTabContent(activeTabs)}</div>
      <ModalUnverifiedUser
        type={unverifiedType}
        isShow={isShowModal}
        setIsShow={setIsShowModal}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataUser: state.dataAuth.userdata,
    dataAuth: state.dataAuth,
    dataCashOut: state.dataDisbursement.cashout,
    dataUserBank: state.dataPostalCode.userBankAccount.data,
    dataDisbursement: state.dataDisbursement.disbursement,
    dataWalletLog: state.dataDisbursement.balance,
    dataSetting: state.dataDisbursement.disbursementSetting,
    dataCashOutFee: state.dataDisbursement.cashoutFee,
    isSubmit: state.dataDisbursement.disbursement.isSubmit,
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
  };
};

const mapDispatchToProps = (dispatch: (arg: any) => any) => {
  return {
    topUpHistory: (query: any) => dispatch(walletHistory(query)),
    doDisbursementHistory: (query: any) => dispatch(disbursementHistory(query)),
    doPendingCashOut: (query: any) => dispatch(cashOutHistory(query)),
    topup: (payload: any) => dispatch(doTopUp(payload)),
    getUserBankAccount: () => dispatch(doFetchUserBankAccount()),
    getDisbursementSetting: () => dispatch(getDisbursementSetting()),
    doDisbursement: (payload: any) => dispatch(doDisbursement(payload)),
    getSellerCashOutFee: (query: any) => dispatch(getSellerCashOutFee(query)),
    getProfile: () => dispatch(doFetchProfile()),
    doRefreshToken: () => dispatch(doRefreshToken()),
    doSentCitCall: (payload) => dispatch(doSentCitCall(payload)),
    doSentSMS: (payload) => dispatch(doSentSMS(payload)),
    doVerifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
    doSubmitPhone: (payload) => dispatch(doSubmitPhone(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SellerCreditHistory);
